import ReviewStars from "../reviewStars";


interface Props {
  text: string;
  reviews: any;
}
const LocalizedSoldDevices = (props: Props) => {
  const {
    text,
    reviews
  } = props;
  return (
    <div className="mt-4 mb-2 flex flex-col sm:flex-row sm:gap-8 sm:mb-0 items-center justify-center">
      {reviews && (
        <div className="">
          <ReviewStars rating={reviews?.totalAverage} numberOfReviewers={reviews?.data?.length} />
        </div>
      )}
      {text && <span className="text-primary-mono-1 text-center text-xl">{text}</span>}
    </div>
  );
};

export default LocalizedSoldDevices;
